import { defineComponent as _defineComponent } from 'vue'
import {
  computed, PropType, ref, toRefs
} from 'vue';
import ProjectMinimalListItem from '@/views/project-forum/components/ProjectMinimalListItem.vue';
import { ProjectListProject } from '@/views/project-forum/models/ProjectForum';
import ProjectSelector from '@/views/project-forum/components/sidebar-actions/ProjectSelector.vue';
import MinusCircleIcon from '@/components/svg/minus-circle.svg?inline';
import useResponsiveness from '@/mixins/useResponsiveness';
import X from '@/components/svg-components/X.vue';
import { CompanyGuestListResponse } from '@/models/Company';
import { useProjectGuests } from '../composables/useProjectGuests';


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberProjectList',
  props: {
  member: {
    type: Object as PropType<CompanyGuestListResponse>,
    required: true,
  },
},
  emits: ['add-member-project', 'delete-member-project'],
  setup(__props, { emit }) {

const props = __props;





const { isMobileWidth } = useResponsiveness();
const { member } = toRefs(props);

const projects = computed(() => member.value.projects);
const { projectList, projectName } = useProjectGuests();
const selectedProject = ref<ProjectListProject | null>(null);

const remainingProjectsList = computed(
  () => projectList.value.filter(
    (project) => !projects.value.some(
      (addedProject) => addedProject.id === project.id
    )
  )
);

const onSelectProject = (project: ProjectListProject) => {
  projectName.value = project.title;
  selectedProject.value = project;
  emit('add-member-project', project);
  projectName.value = '';
};

const canAssignProjects = computed(() => props.member?.active && props.member.userRegistrationStatus !== 'NONE');


return { __sfc: true,props, emit, isMobileWidth, member, projects, projectList, projectName, selectedProject, remainingProjectsList, onSelectProject, canAssignProjects, ProjectMinimalListItem, ProjectSelector, MinusCircleIcon, X }
}

})